export type FontsWeight = {
    regular: string
    medium: string
    bold: string
}

export const fonts: FontsWeight = {
    regular: 'julisans-regular-webfont.woff2?v=2',
    medium: 'julisans-medium-webfont.woff2?v=2',
    bold: 'julisans-bold-webfont.woff2?v=2',
}

export function useFonts(): string {
    const config = useRuntimeConfig()
    const fontFaces: string = `
        @font-face { ascent-override: 92%; font-family: "Juli"; src: url("${config.app.cdnURL}/fonts/${fonts.regular}") format("woff2"); font-weight: 400; font-style: normal; font-display: swap; }
        @font-face { ascent-override: 92%; font-family: "Juli"; src: url("${config.app.cdnURL}/fonts/${fonts.medium}") format("woff2"); font-weight: 500; font-style: normal; font-display: swap; }
        @font-face { ascent-override: 92%; font-family: "Juli"; src: url("${config.app.cdnURL}/fonts/${fonts.bold}") format("woff2"); font-weight: 700; font-style: normal; font-display: swap; }`

    return fontFaces
}

export function useFontsLoader(): void {
    if (import.meta.client) {
        const config = useRuntimeConfig()

        if (sessionStorage.fontsLoaded) {
            document.documentElement.classList.add('fonts-stage-2')
        } else {
            var fontBold = new FontFace(
                'Juli',
                `url(${config.app.cdnURL}/fonts/${fonts.bold})`
            )
            Promise.all([fontBold.load()]).then(function () {
                document.documentElement.classList.add('fonts-stage-2')
                sessionStorage.fontsLoaded = true
            })
        }
    }
}
